import { Articles } from "features/landing/data/models/article";
import { useEffect, useState } from "react";
import Routes from "router/routes";
import { useNavigate } from "react-router-dom";

const NextReadCard = ({articles,slug}:{articles:Articles[],slug:string}) =>{
    const [nextRead,setNextRead] = useState<Articles | null>(null);
    const navigate = useNavigate();
    useEffect(() => {
        const filteredArticles = articles?.filter(
            (article) =>
                article.tags?.some((tag) => tag.name === "Fundraiser")
        );
        if (filteredArticles && filteredArticles.length > 1) {
            const currentIndex = filteredArticles.findIndex(a => a.slug === slug);
            const nextIndex = currentIndex === -1
                ? 0
                : (currentIndex + 1) % filteredArticles.length;
            if (filteredArticles[nextIndex].slug !== slug) {
                setNextRead(filteredArticles[nextIndex]);
            } else {
                setNextRead(null);
            }
        } else {
            setNextRead(null);
        }
    }, [articles, slug]);
    if (!nextRead) {
        return null;
    }

    return (<div className="border lg:mt-[50px] mt-[40px] border-[#FFEBA8] bg-[#FFFBED] lg:px-6 lg:py-8 px-3 py-3 flex flex-row gap-4 rounded-[8px] cursor-pointer" onClick={() => navigate(Routes.FUNDRAISER_BLOG_DETAILS(nextRead.slug))}>

        <div className="flex flex-col ">
            <img src={`${process.env.REACT_APP_STRAPI_URL}${nextRead.cover?.formats?.small?.url}`} alt="article-img" className="rounded-[8px] lg:h-[146px] lg:w-[146px] h-[80px] w-[120px] object-cover"/>
        </div>
        <div className="flex flex-col gap-2 items-start justify-center">
            <p className="font-bold font-inter text-[12px] lg:text-[16px] leading-[100%] tracking-[-1.5%] text-[#F79009]">NEXT READ</p>
            <p className="text-[#7E4510] font-inter text-[14px] lg:text-[24px] lg:font-extrabold lg:leading-[40px] leading-[24px] tracking-[-1.5%] ">{nextRead.title}</p>
        </div>

    </div>)
}

export default NextReadCard;
